module.exports = __webpack_public_path__ + "static/media/Fr. Graceson.fc841414.png";